import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import React from 'react';
import { ERROR, HIGHLIGHT, PLACEHOLDER, TEXT } from '../Colors';
import { BODY, MINI_HEADER } from '../Fonts';

const StyledTextField = withStyles({
    root: {
        width: '100%',
        '& .MuiInputLabel-root': { // Label as placeholder
            font: BODY,
            color: PLACEHOLDER
        },
        '& .MuiInputLabel-root.Mui-error': { // Label error
            color: ERROR
        },
        '& .MuiInputLabel-root.Mui-error.Mui-focused': { // Label error focused
            color: ERROR
        },
        '& .MuiInputLabel-root.Mui-focused': { // Label on top focused
            color: HIGHLIGHT
        },
        '& .MuiInputLabel-root.Mui-disabled': { // Label on top focused
            opacity: 0.5
        },
        '& .MuiInputLabel-shrink': { // Label on top 
            font: MINI_HEADER,
            transform: 'scale(1.0)'
        },
        '& .MuiInput-root.Mui-disabled': { // Input
            opacity: 0.5
        },
        '& .MuiInput-input': { // Input
            font: BODY,
            color: TEXT
        },
        '& .MuiInput-input:focus': { // Input focused
            color: PLACEHOLDER
        },
        '& .MuiInput-underline.Mui-error:after': {
            borderBottom: `1px solid ${TEXT}`
        },
        '& .MuiInput-underline.Mui-error.Mui-focused:after': {
            borderBottom: `1px solid ${HIGHLIGHT}`
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: `2px solid ${TEXT}`
        },
        '& .MuiInput-underline.Mui-focused:hover:not(.Mui-disabled):before': {
            borderBottomWidth: '1px'
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: TEXT
        },
        '& .MuiInput-underline:after': {
            borderBottom: `1px solid ${HIGHLIGHT}`
        },
        '& .MuiFormHelperText-root.Mui-error': {
            font: MINI_HEADER,
            color: ERROR
        },
        '& .MuiInputBase-inputMultiline::-webkit-scrollbar': {
            width: `6px`
        },
        '& .MuiInputBase-inputMultiline::-webkit-scrollbar-thumb ': {
            backgroundColor: `rgba(0,0,0,.4)`,
            borderRadius: `3px`
        }
    },
})(MuiTextField);

const useStyles = makeStyles({
    hidden: {
        display: 'none',
    }
});

interface TextFieldProps {
    multiline?: boolean,
    rows?: number,
    value?: string,
    placeholder: string,
    hidden?: boolean,
    disabled?: boolean,
    readonly?: boolean,
    error?: boolean | string,
    autoFocus?: boolean,
    onChange?(value: string): void
    onChangeCompleted?(value: string): void
}

export const TextField: React.FunctionComponent<TextFieldProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onChange = (value: string) => {
        if (props.onChange) {
            props.onChange(value);
        }
    }
    const onChangeCompleted = (value: string) => {
        if (props.onChangeCompleted) {
            props.onChangeCompleted(value);
        }
    }

    const className = `${props.hidden ? classes.hidden : ''} ${stylingClassName}`;

    return (
        <StyledTextField
            className={className}
            error={props.error ? true : false}
            helperText={typeof props.error === "string" ? props.error : null}
            label={props.placeholder}
            value={props.value}
            disabled={props.disabled}
            autoFocus={props.autoFocus}
            multiline={props.multiline}
            rows={props.rows}
            InputProps={{readOnly: props.readonly || false}}
            onChange={ev => onChange(ev.target.value)}
            onBlur={ev => onChangeCompleted(ev.target.value)} />
    );
}
